/* eslint-disable import/no-cycle */
import React, { useState } from 'react'

import CtaButton from '../CtaButton/CtaButton'
import richTextRenderer from '../RichTextParser/RichTextParser'
import {
  btnMargin,
  contactStepTitle,
  pageReadMore,
  readMore,
  readMoreHome,
  separatorLine,
  // spanNumber,
  stepContent,
  stepContentContainer,
  stepsCard,
  stepsHeader,
  stepsOpened,
  stepTitle,
} from './StepItem.module.css'

const StepItem = ({
  component,
  contactStep,
  extraClassName,
  // index,
  step,
  vacanciesStep,
}) => {
  const [open, setOpen] = useState(false)
  const { content, stepcontent, steptitle, title } = step
  const stepHeading = title || steptitle
  const stepRichContent = content || stepcontent

  return (
    <div className={`${stepsCard} ${extraClassName}`}>
      <div className={contactStep ? '' : stepsHeader}>
        {/* {!vacanciesStep && !contactStep && (
          <span className={spanNumber}>{getHexadecimal(index + 1)}</span>
        )} */}
        {vacanciesStep && !contactStep && (
          <div className={`${separatorLine}`} />
        )}
        {stepHeading && (
          <h3 className={`${contactStep ? contactStepTitle : stepTitle}`}>
            {stepHeading}
          </h3>
        )}
      </div>
      <div className={stepContent}>
        {stepRichContent && (
          <div
            className={`${
              contactStep || vacanciesStep || component === 'category'
                ? ''
                : stepContentContainer
            } ${open ? stepsOpened : ''}`}
          >
            {richTextRenderer(stepRichContent)}
          </div>
        )}
        {stepRichContent &&
          stepRichContent.length > 500 &&
          !open &&
          !vacanciesStep && (
            <div
              className={`${readMore} ${
                component === 'processsection' ? readMoreHome : pageReadMore
              }`}
            />
          )}
        {stepRichContent &&
          stepRichContent.length < 500 &&
          !contactStep &&
          !vacanciesStep && (
            <div
              className={!vacanciesStep ? `${separatorLine} ${btnMargin}` : ''}
            />
          )}
      </div>
      {stepRichContent && stepRichContent.length > 500 && !vacanciesStep && (
        <CtaButton
          className={btnMargin}
          onClick={() => setOpen(!open)}
          title="Read more"
          type="secondary"
        />
      )}
    </div>
  )
}

export default StepItem
